import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import MobileMenu from './mobile-menu/MobileMenu'

const drawerWidth = 280
const styles = {
  drawer: {
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
}

class RightDrawer extends Component {
  render() {
    const { classes } = this.props
    return (
      <nav className={classes.drawer}>
        <Drawer
          container={this.props.container}
          variant="temporary"
          anchor={'right'}
          open={this.props.isRightDrawerOpen}
          onClose={this.props.toggleRightDrawer}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <MobileMenu
            openContactDialog={this.props.openContactDialog}
            openHelpDialog={this.props.openHelpDialog}
            closeDrawer={this.props.toggleRightDrawer}
          />
        </Drawer>
      </nav>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    mindfile: state.mindfile,
  }
}

const styledComponent = withStyles(styles)(RightDrawer)

export default connect(mapStateToProps)(styledComponent)
